import UnloadConfirmation from 'unload_confirmation'
let userInfoUnloadConfirmation = new UnloadConfirmation()
let tabUnloadConfirmation = new UnloadConfirmation()

$(document).ready(function() {
  // 応対履歴の新規/編集画面で、読み込み時に確認ダイアログを有効化
  var url = window.location.href;
  if (url.includes("callcenter_logs")) {
    if (!tabUnloadConfirmation.isActive()) {
      userInfoUnloadConfirmation.enable()
    }
  }
  addConfirmationBeforeSwitchTab()

  // 応対履歴の新規/編集画面で、ページを離れる前に確認ダイアログを表示
  $('#cl_log-fin').on('click', function() {
    // ここにinputが押された時の処理を記述する
    userInfoUnloadConfirmation.disable()
  });
  $('#cl_log-cancel').on('click', function() {
    // ここにinputが押された時の処理を記述する
    userInfoUnloadConfirmation.disable()
  });
})

function addConfirmationBeforeSwitchTab() {
  $('#custom-content-below-tab').on('show.bs.tab', function (e) {
    // タブの離脱防止アラートが有効状態の場合のみ、確認ダイアログを表示
    if (tabUnloadConfirmation.isActive()) {
      const confirmationMessage = '行った変更が保存されない可能性があります。';
      if (confirm(confirmationMessage)) {
        // ユーザーが「はい」を選択した場合、tabUnloadConfirmation.disable()を実行
        tabUnloadConfirmation.disable()
      } else {
        // ユーザーがキャンセルした場合、タブ移動をキャンセル
        e.preventDefault()
      }
    }
  })
}
